import React, { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Button, Box } from "@mui/material";
import AdminLessons from "./AdminLessons";
import ShowLessons from "./ShowLessons";
import { startTour,stopTour } from "../../../redux/globalJoyrideSlice";
import { weeklyLessonsTourSteps } from "../../../tour/teacherPlanerTourSteps"

const WeeklyLessonNav = () => {
  const [activeTab, setActiveTab] = useState("lesson");
const dispatch = useDispatch();
const navigate=useNavigate();

  useEffect(() => {
    dispatch(
  startTour({
    activeTour: "weekly-lessons",
    steps: weeklyLessonsTourSteps({
      dispatch,navigate,
      stopTour: () => dispatch(stopTour()),
    }),
    stepIndex: 1,
  })
);
  }, [dispatch]);
  return (
    <Box>
      <Box sx={{ display: "flex", gap: 2, mb: 2, marginLeft: 6 }}>
        <Button
          variant={activeTab === "lesson" ? "contained" : "outlined"}
          onClick={() => setActiveTab("lesson")}
        >
          All Teachers Plan
        </Button>
        <Button
          data-tour="weekly-tab-my"
          variant={activeTab === "homework" ? "contained" : "outlined"}
          onClick={() => setActiveTab("homework")}
        >
          My Weekly plan
        </Button>
      </Box>
      <Box>
        {activeTab === "lesson" && <AdminLessons />}
        {activeTab === "homework" && <ShowLessons />}
      </Box>
    </Box>
  );
};

export default WeeklyLessonNav;
